import styled from "styled-components";

const ColorInfo = () => {
  return (
    <ColorInfoContainer>
      <Circle color="blue" />
      <Text>09:00 ~ 16:00</Text>
      <Circle color="red" />
      <Text>Include 12:00</Text>
    </ColorInfoContainer>
  );
};

export default ColorInfo;

const ColorInfoContainer = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  padding: 0.5rem;
  /* background-color: #001526; */
  font-size: 1rem;
  font-weight: 500;
  white-space: nowrap;
`;

const Circle = styled.div`
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  background-color: ${prop => prop.color || "white"};
`;

const Text = styled.p`
  margin-right: 0.7rem;
  margin-left: 0.3rem;
`;
